export const INITIAL_STATE = {
    ratioType: '',
    accumulationRatio: '',
    loyaltyTierId: '',
    loading: false,
    tiersLoading: false,
    tiers: [],
    error: '',
    fieldErrors: {},
};

export const TOAST_MESSAGES = {
    success: 'MCC Code added successfully!',
    error: 'Failed to add MCC Code. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
    ratioType: 'MCC Code is required.',
    ratioTypeNumeric: 'MCC Code must contain numbers only.',
    accumulationRatio: 'Accumulation ratio is required and must be greater than 0.',
    loyaltyTierId: 'Loyalty tier is required.',
};
